import React, { useEffect, useState } from 'react';
import Loading from '@components/Loading';
import Chart from '@components/charts/Chart';
import { apiGetDeviceStatisticsByBranch } from '@services/ManageDevices/DeviceServices';
import { showError } from '@components/notification';
import { formatCurrency } from '@utils/utils';

const DeviceAllocationChart = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await apiGetDeviceStatisticsByBranch();
      console.log('Device allocation data:', res.data);

      if (res.data?.data?.branches) {
        const responseData = Array.isArray(res.data.data.branches) ? res.data.data.branches : [];
        setData(responseData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error('Error fetching device allocation data:', error);
      showError('Không thể tải dữ liệu phân bổ thiết bị');
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Convert branch name to abbreviated form
  const convertToAbbreviation = (branchName) => {
    if (!branchName) return '';
    // const cleanName = branchName.replace(/Nhà máy\s*/gi, '').trim();
    // return cleanName
    //   .split(' ')
    //   .map((word) => word.charAt(0).toUpperCase())
    //   .join('');
    return branchName;
  };

  const categories = Array.isArray(data)
    ? data.map((item) => convertToAbbreviation(item.branch_name) || item.branch_code)
    : [];

  const onlineData = Array.isArray(data)
    ? data.map((item) => parseInt(item.total_online || 0))
    : [];

  const offlineData = Array.isArray(data)
    ? data.map((item) => parseInt(item.total_offline || 0))
    : [];

  const series = [
    {
      name: 'Online',
      data: onlineData,
      color: '#52c41a'
    },
    {
      name: 'Offline',
      data: offlineData,
      color: '#ff4d4f'
    }
  ];

  return (
    <div>
      {loading ? (
        <div className="loading-container">
          <Loading />
        </div>
      ) : (
        <div className="chart-container">
          <Chart
            options={{
              chart: {
                type: 'bar',
                stacked: true,
                toolbar: {
                  show: true
                }
              },
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: '50%',
                  borderRadius: 0
                }
              },
              dataLabels: {
                enabled: true,
                style: {
                  fontSize: '12px',
                  fontWeight: 'bold',
                  colors: ['#fff']
                },
                formatter: (val) => (val > 0 ? formatCurrency(val, 0) : '')
              },
              stroke: {
                show: true,
                width: 1,
                colors: ['#fff']
              },
              xaxis: {
                categories: categories
              },
              yaxis: {
                title: {
                  text: 'Số lượng thiết bị'
                }
              },
              grid: {
                show: true
              },
              tooltip: {
                y: {
                  formatter: (val) => `${formatCurrency(val, 0)} thiết bị`
                }
              },
              legend: {
                position: 'top',
                horizontalAlign: 'left'
              },
              fill: {
                opacity: 1
              }
            }}
            type="bar"
            series={series}
            height={350}
          />
        </div>
      )}
    </div>
  );
};

export default DeviceAllocationChart;
